<template>
  <div>
    <p class="font-12">
      提示：{{ userName }} 将可以查看下面被勾选范围的客户和订单等数据。
    </p>
    <div>
      <el-checkbox v-model="adminCheck" v-if="isSuperAdmin"
        >所有资源（将会看到所有数据，建议管理角色勾选此项）</el-checkbox
      >
    </div>
    <div
      v-if="!adminCheck"
      class="select-container"
      v-for="(item, index) in resources"
    >
      <div v-if="!isadealer">
        <span class="font-weight-bold res-title">{{ item.name }}</span>
        <el-radio class="mr-20 type-item" v-model="item.all_area" :label="0"
          >指定人员</el-radio
        >
        <el-radio class="type-item" v-model="item.all_area" :label="1"
          >全区域</el-radio
        >
      </div>
      <div class="" style="padding-left: 100px">
        <!-- <el-checkbox
      v-model="checkAll"
      @change="handleCheckAllChange"
      :disabled="disabled"
      v-show="options.length > 0"
      >全选</el-checkbox
    >
    <div style="margin: 15px 0"></div> -->
        <el-checkbox-group v-model="item.selected">
          <el-checkbox
            class="user-select"
            v-for="it in item.items"
            :label="it.id"
            :key="it.id"
            :value="it.id"
            :disabled="item.all_area == 1"
            >{{ it.name }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </div>
    <el-button
      style="margin-top: 20px"
      size="small"
      type="primary"
      class="mobile-ml-0"
      @click="submit"
      >保 存</el-button
    >
  </div>
</template>


<script>
import {
  resourceList,
  userResourceList,
  setUserResource,
} from '@/service/getData'
import { isMobile } from '@/util/index'
import Rselect from '@/views/resource/selector'
import store from '@/store/store'
import { userSwithAdmin } from '../../service/getData'

export default {
  props: {
    userID: 0,
    userName: '',
    userMark: 0,
    areaID: 0,
  },
  components: {
    Rselect,
  },
  data() {
    return {
      all: 0,
      activeName: '',
      adminCheck: false,
      isMobile,
      resources: [],
      user: {},
      isSuperAdmin: store.getters.userInfo.is_super_admin,
      isadealer: store.getters.userInfo.dealer_id > 0,
    }
  },
  watch: {
    areaID() {
      this.getResources()
    },
    userMark() {
      this.adminCheck = this.userMark == 2
    },
  },
  created() {
    this.getResources()
  },
  methods: {
    async getResources() {
      let res = await resourceList()
      let filterPlatform = this.isadealer ? 1 : 2
      if (res.code == 0) {
        this.resources = res.data.list
          .filter((it) => it.platform != filterPlatform)
          .map((item) => {
            item.items.map((it) => {
              it.id = parseInt(it.value)
            })
            this.$set(item, 'selected', [])
            this.$set(item, 'all_area', 0)
            return item
          })

        if (!this.isadealer) {
          this.resources = this.resources
            .filter((item) => item.key == 'area')[0]
            .items.map((item) => {
              item.items = this.resources[0].items.filter(
                (it) => it.area_id == item.id
              )
              this.$set(item, 'selected', [])
              this.$set(item, 'all_area', 0)
              this.$set(item, 'area_id', item.id)
              item.key = item.id.toString()
              return item
            })
        }
        this.getUserResources()
      }
    },
    async getUserResources() {
      if (!parseInt(this.userID) > 0) {
        this.resources.map((item) => {
          item.selected = []
        })
        return
      }
      let res = await userResourceList({
        user_id: this.userID,
        key: '',
      })
      if (res.code == 0) {
        this.resources.map((item) => {
          let selected = []
          if (this.isadealer) {
            selected = res.data.list.filter((i) => i.key == item.key)
          } else {
            let filterItems = res.data.list.filter(
              (i) => i.area_id.toString() == item.key
            )

            if (filterItems[0]) {
              item.all_area = filterItems[0].all_area
            }

            selected = filterItems.filter((i) =>
              item.items.some((it) => eval(i.value).indexOf(it.id) != -1)
            )
          }
          if (selected.length > 0) {
            item.selected = eval(selected[0].value)
          } else {
            item.selected = []
          }
        })
      }
    },
    async submit() {
      // 标记管理员
      if (this.isSuperAdmin) {
        let res = userSwithAdmin({
          id: this.userID,
          admin: this.adminCheck,
        })

        if (this.adminCheck) {
          this.$message.success('保存成功')
          return
        }
      }

      let data = {
        key: 'user',
        user_id: this.userID,
        resources: [],
      }
      data.resources = this.resources.map((item) => {
        return {
          value: item.selected,
          area_id: item.area_id || 0,
          all_area: item.all_area,
        }
      })
      let res2 = await setUserResource(data)
      if (res2.code == 0) {
        this.$message.success('保存成功')
      }
    },
  },
}
</script>

<style>
.el-tabs--border-card,
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background: #ffffff;
}
</style>

<style scoped>
.long {
  width: 100%;
}
.res-title {
  width: 100px;
  display: inline-block;
}
.type-item {
  width: 140px;
}
.user-select {
  width: 140px;
  margin-top: 20px;
}
.select-container {
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

/* /deep/.el-checkbox {
  width: 120px;
} */
</style>